import {
  parseRunFilters,
  parseTraceSearch,
  runFiltersToSearch,
  type IRunFilters,
  type ITraceSearch,
  type TTraceTab,
} from './filters';

// The trigger step adds two tabs the other steps do not have: the request and its bytes.
export type TTraceViewTab = TTraceTab | 'request' | 'raw';

export interface ITraceView extends Omit<ITraceSearch, 'tab'> {
  tab?: TTraceViewTab;
}

const EXTRA_TABS: readonly TTraceViewTab[] = ['request', 'raw'];

export const parseTraceView = (search: Record<string, unknown>): ITraceView => {
  const base = parseTraceSearch(search);
  const extra = EXTRA_TABS.find((tab) => tab === search.tab);
  return { ...base, tab: base.tab ?? extra };
};

// The Events filter rides along on the trace URL, so ↑ / ↓ walk the list the user came from
// and the crumb goes back to it. Its keys and the trace's never overlap.
export const traceListFilters = (search: Record<string, unknown>): IRunFilters =>
  parseRunFilters(search);

export const traceSearch = (
  view: ITraceView,
  list: IRunFilters,
): Record<string, string | number> => {
  const out: Record<string, string | number> = { ...runFiltersToSearch(list) };
  for (const key of ['at', 'copy', 'step', 'tab', 'view', 'rec'] as const) {
    const value = view[key];
    if (value) out[key] = value;
  }
  return out;
};
